import { Flex } from '@mantine/core';
import { ConfigurationTab } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/AutomatedEmails/ConfigurationTab';
import { StyledSettingsContainer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/styles';

interface Props {
	organizationId: string;
}

export const ProgrammeDefaultsEmailReminders = ({ organizationId }: Props) => {
	return (
		<StyledSettingsContainer>
			<Flex direction="column" w="100%">
				<ConfigurationTab organizationId={organizationId} />
			</Flex>
		</StyledSettingsContainer>
	);
};
